// Short-label mappings for the per-traveler `ticket_class` field.
//
// We deliberately keep two parallel maps (flight vs train) because the same
// raw value can mean different things in different modes — e.g. "Economy" on
// a flight is "Econ" but on a train is "2nd Class" (industry shorthand for
// what European/Asian rail networks call standard/second class seating).
//
// Returns a short label suitable for an inline chip, or null when nothing
// is set / the value isn't recognized for that segment type.

const FLIGHT_SHORT = {
  economy: "Econ",
  "premium economy": "Prem Eco",
  business: "Biz",
  first: "1st",
};

const TRAIN_SHORT = {
  // 2nd-class equivalents — different operators name it differently.
  standard: "2nd Class",
  second: "2nd Class",
  economy: "2nd Class",
  // Premium tiers
  premium: "Prem",
  business: "Biz",
  first: "1st Class",
  // Specialty
  sleeper: "Sleeper",
  couchette: "Couchette",
};

export const getShortTicketClass = (rawValue, segmentType) => {
  if (!rawValue) return null;
  const key = String(rawValue).trim().toLowerCase();
  if (!key) return null;
  if (segmentType === "flight") return FLIGHT_SHORT[key] || null;
  if (segmentType === "train") return TRAIN_SHORT[key] || null;
  return null;
};

// Pick the most-likely-shared class across travelers — first non-empty value.
// In practice every party books the same class, so this is the right default.
// Segment-level `ticket_class` wins when present (set by reconciliation and
// by bulk-add for flights) since it represents the booking-wide value rather
// than a per-pax override.
export const getSegmentTicketClass = (segment) => {
  if (segment?.ticket_class) return segment.ticket_class;
  const details = segment?.traveler_details;
  if (!Array.isArray(details)) return null;
  for (const td of details) {
    if (td && td.ticket_class) return td.ticket_class;
  }
  return null;
};
